import InternalShareScreenIcon from './internal/icons/ShareScreenIcon'
import InternalCard from './internal/InternalCard'
import InternalButton from './internal/InternalButton'
import { Username } from '../Username'
import { Trans, useTranslation } from 'react-i18next'
import MicrophoneIcon from '@/CustomIcons/MicrophoneIcon'
import CursorIcon from '@/CustomIcons/CursorIcon'
import RecordScreenIcon from '@/CustomIcons/RecordScreenIcon'

const rightButtonStyle = 'pl-3 pr-4 border-l-black/20 border-l hover:bg-black/10 text-black t-sm-light'
const leftIconColor = 'text-black'

export function PresentingCard({ onStopClicked }: { onStopClicked: () => void }) {
    const { t } = useTranslation()

    return (
        <InternalCard className="rounded-[16px] pl-4 pr-0 app-window-drag-region text-black justify-between">
            <span className={leftIconColor}>
                <InternalShareScreenIcon />
            </span>
            <span className="t-sm px-2">{t('Sharing Screen')}</span>
            <InternalButton onClick={onStopClicked} className={rightButtonStyle} title="Stop Sharing Screen">
                {t('Stop')}
            </InternalButton>
        </InternalCard>
    )
}

export function ScreenRecordingCard({ onStopClicked }: { onStopClicked: () => void }) {
    const { t } = useTranslation()

    return (
        <InternalCard className="rounded-[16px] px-0 pl-4 app-window-drag-region text-black">
            <RecordScreenIcon className={leftIconColor} style={{ fontSize: '1.3rem' }} />
            <span className="t-sm px-2">{t('Recording Screen')}</span>
            <InternalButton onClick={onStopClicked} className={rightButtonStyle}>
                {t('Stop')}
            </InternalButton>
        </InternalCard>
    )
}

export function DesktopControllingCard({ onStopClicked }: { onStopClicked: () => void }) {
    const { t } = useTranslation()

    return (
        <InternalCard className="rounded-[16px] px-0 pl-4 app-window-drag-region text-black">
            <CursorIcon className={leftIconColor} style={{ fontSize: '1.3rem' }} />
            <span className="t-sm px-2">{t('Remove Control')}</span>
            <InternalButton onClick={onStopClicked} className={rightButtonStyle}>
                {t('Stop')}
            </InternalButton>
        </InternalCard>
    )
}

export function RemoteRecorderPeerCard({ remoteRecorderPeer }: { remoteRecorderPeer: string }) {
    const { t } = useTranslation()
    return (
        <InternalCard className="rounded-[16px] px-4 app-window-drag-region gap-2 text-black">
            <MicrophoneIcon className={leftIconColor} style={{ fontSize: '1.3rem' }} />
            <span className="t-sm">
                <Trans
                    i18nKey="<0/> is recording you"
                    t={t}
                    components={[<Username username={remoteRecorderPeer} noTooltip />]}
                />
            </span>
        </InternalCard>
    )
}

export function RemoteRecordingPeerCard({
    remoteRecordingPeer,
    onStopClicked,
}: {
    remoteRecordingPeer: string
    onStopClicked: (event: any) => void
}) {
    const { t } = useTranslation()

    return (
        <InternalCard className="rounded-[16px] px-0 pl-4 app-window-drag-region text-black gap-2">
            <MicrophoneIcon className={leftIconColor} style={{ fontSize: '1.3rem' }} />
            <span className="t-sm">
                <Trans
                    i18nKey="Recording <0/>"
                    t={t}
                    components={[<Username username={remoteRecordingPeer} noTooltip />]}
                />
            </span>
            <InternalButton onClick={onStopClicked} className={rightButtonStyle} title="Stop Recording">
                {t('Stop')}
            </InternalButton>
        </InternalCard>
    )
}

export function SessionRecordingCard({ sessionRecordingPeer }: { sessionRecordingPeer: string }) {
    const { t } = useTranslation()

    return (
        <InternalCard className="rounded-[16px] px-4 app-window-drag-region text-black gap-2">
            <RecordScreenIcon className={leftIconColor} style={{ fontSize: '1.3rem' }} />
            <span className="t-sm">
                <Trans
                    i18nKey="<0/> is recording this session"
                    t={t}
                    components={[<Username username={sessionRecordingPeer} noTooltip />]}
                />
            </span>
        </InternalCard>
    )
}
